export var EXAMINATION_SUBMISSION_REPOSITORY = 'EXAMINATION_SUBMISSION_REPOSITORY';